export const isMockMode = (): boolean => {
  try {
    const qs = new URLSearchParams(window.location.search);
    const v = (qs.get('mock') || '').toLowerCase();
    if (v === '1' || v === 'true' || v === 'yes') return true;
  } catch {
    // ignore
  }
  return false;
};

export const MOCK_MODE = isMockMode();
